import React, { useEffect } from "react";
import service1 from "../../assets/img/service_6.png";
import phone_icon from "../../assets/img/phone.png";
import { ReactTyped } from "react-typed";
import AOS from "aos";
import "aos/dist/aos.css";
import "../../App.css";
import { Link } from "react-router-dom";

const AfterBuildersCleaning = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <div className="service_detail_page">
      <h2 className="service_detail_title" data-aos="fade-down">
        Post Construction Cleaning
      </h2>

      <img
        src={service1}
        alt="Post Construction Cleaning"
        className="service_detail_image"
        data-aos="zoom-in"
      />

      <p className="service_detail_cta" data-aos="fade-up">
        Handover ready. Structured. Signed off.
      </p>

      <p className="service_detail_desc" data-aos="fade-up">
        Post construction cleaning in Auckland delivered with site awareness and
        programme discipline. We work alongside builders, developers and
        project managers to align with build timelines, staged cleans and final
        presentation requirements.
      </p>

      <p className="service_detail_desc" data-aos="fade-up">
        Every project runs through a defined workflow. Scope confirmation, site
        induction where required, scheduled attendance, documented completion
        and clear invoicing. Health and Safety documentation and compliance
        records are available to support handover.
      </p>

      <p className="service_detail_desc" data-aos="fade-up">
        This is not a last minute clean. It is a controlled finish that
        protects the standard of your build.
      </p>

      <h4 className="service_subheading" data-aos="fade-up">
        Who We Work With
      </h4>
      <ul className="service_detail_points" data-aos="fade-up">
        <li>Developers and group housing companies</li>
        <li>Project and site managers</li>
        <li>Renovation and fit out contractors</li>
        <li>Commercial and residential new builds</li>
      </ul>

      <h4 className="service_subheading" data-aos="fade-up">
        Why Luxe Sparkle
      </h4>
      <ul className="service_detail_points" data-aos="fade-up">
        <li>Aligned to build schedules and staged handovers</li>
        <li>Health and Safety systems integrated into delivery</li>
        <li>Clear communication with site contacts</li>
        <li>Documented completion and professional reporting</li>
      </ul>

      <p className="service_detail_cta" data-aos="fade-up">
        You complete the build. We support the presentation.
      </p>

      <div className="service_btn_wrapper" data-aos="fade-up">
        <Link to="/booking" className="service_btn">
          Get a Free Quote
        </Link>
      </div>

      <div className="service_contact_section">
        <div className="about_sub2">
          <div className="about_contact">
            <p className="contact-lead">
              Looking for the cleaning service in Auckland?
              <br />
              Contact us now!
            </p>
            <div className="call_btn" data-aos="fade-down">
              <div className="call_inner">
                <div className="call_icon">
                  <img src={phone_icon} alt="Phone" />
                </div>
                <a className="call-button" href="tel:092430470">
                  09 243 0470
                </a>
              </div>
            </div>
          </div>

          <div className="about_faq">
            <ReactTyped
              strings={["Need help?", "Have questions?", "Check our FAQs!"]}
              typeSpeed={50}
              backSpeed={30}
              loop
            />
            <br />
            <Link className="faq-button" to="/FAQs">
              FAQs
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AfterBuildersCleaning;
